'use strict';
import angular from 'angular';

angular.module('flowingly.runner.redirect', []);
